module.exports = __webpack_public_path__ + "static/media/landingCollaborator9.24e77f55.jpg";